import { useEffect, useState } from "react";
import { API_STATUS } from "../../constants";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { reloadState } from "../../redux/GlobalSlice";
import { EditProfileApi } from "../../apis/user/edit_profile_api";

export default function EditProfileForm({ userData }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [MainCat, setMainCat] = useState(userData['category']);
    const [SubCat, setSubCat] = useState(userData['subCat']);
    const [editApi, setEditApi] = useState(API_STATUS);
    const [selectCat, setSelectCat] = useState(false);
    const [birthday, setBirthday] = useState('');
    const [loginType, setLoginType] = useState('');

    const phoneRegExp = /^[0-9\- ]{10,10}$/;

    useEffect(() => {
        const utype = sessionStorage.getItem('USER_TYPE');
        setLoginType(utype);

        let bdate = new Date(userData['dob']);
        setBirthday(bdate.getFullYear() + "-" + (bdate.getMonth() + 1) + "-" + bdate.getDate());
        //setBirthday(bdate.getDate() + "-" + (bdate.getMonth() + 1) + "-" + bdate.getFullYear());
    }, []);

    useEffect(() => {
        if (!editApi.isLoader && !editApi.isError && editApi.data !== null) {
            //dispatch(reloadState({ 'reaload_profile': true }))
            navigate('/profile/' + userData['userId']);
        }
    }, [editApi]);

    const SignupSchema = Yup.object().shape({
        first_name: Yup.string()
            .min(2, 'Too Short!')
            .max(50, 'Too Long!')
            .required('Enter first name'),
        mobile: Yup.string()
            .matches(phoneRegExp, 'Enter valid mobile number')
            .required('Mobile number required'),
        last_name: Yup.string()
            .max(50, 'Too Long!')
            .required('Enter last name'),
        email: Yup.string().email('Invalid email').required('Email id is required'),
        city: Yup.string().required('Enter your city'),
        artist: Yup.boolean(),
        dob: Yup.string().when('artist', {
            is: true,
            then: (schema) => schema.required('Select your birthday')
        }),
        gender: Yup.string().when('artist', {
            is: true,
            then: (schema) => schema.required('Select your gender')
        }),
        company: Yup.string().when('artist', {
            is: false,
            then: (schema) => schema.required('Enter firm/company/agency')
        }),
        state: Yup.string().when('artist', {
            is: false,
            then: (schema) => schema.required('Enter state name')
        }),
        pincode: Yup.string().when('artist', {
            is: false,
            then: (schema) => schema.required('Enter pincode')
        }),
    });

    return <div className="uk-active" style={{ position: 'relative' }}>
        <Formik
            enableReinitialize={true}
            initialValues={{
                artist: userData['category'] == "User" ? true : false,
                first_name: userData['firstName'],
                last_name: userData['lastName'],
                email: userData['email'],
                mobile: userData['mobile'],
                gender: userData['gender'],
                dob: birthday,
                city: userData['city'],
                about: userData['about'],
                social1: userData['social1'],
                social2: userData['social2'],
                social3: userData['social3'],
                user_category: userData['userCat'],
                company: userData['company'],
                gstin: userData['gstin'],
                pan: userData['pan'],
                country: "India",
                state: userData['state'],
                pincode: userData['pincode'],
                category: userData['category'],

            }}
            validationSchema={SignupSchema}
            onSubmit={values => {

                let body = values;
                body.subCat = SubCat;
                body.category = MainCat;
                EditProfileApi(body, setEditApi);
            }}
        >
            {({ values, errors, touched, isValid, handleChange, setFieldTouched, setFieldValue, handleSubmit }) => (
                <div className="space-y-6">

                    <div className="md:flex items-center gap-10">
                        <label className="md:w-32 text-right"> Registered as </label>
                        <div className="flex-1 max-md:mt-4">
                            <input type="text" value={MainCat == "User" ? 'Artist-' + SubCat : MainCat + '-' + SubCat} className="lg:w-1 w-full" />
                        </div>
                    </div>

                    <div className="md:flex items-center gap-10">
                        <label className="md:w-32 text-right"> Sub Category in {SubCat} </label>
                        <div className="flex-1 max-md:mt-4">
                            <Field type="text" name="user_category" className="lg:w-1 w-full" />
                        </div>
                    </div>
                    {
                        errors.user_category && touched.user_category &&
                        <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.user_category}</div>
                    }

                    <div className="md:flex items-center gap-10">
                        <label className="md:w-32 text-right"> First Name </label>
                        <div className="flex-1 max-md:mt-4">
                            <Field type="text" name="first_name" className="lg:w-1 w-full" />
                        </div>
                    </div>
                    {
                        errors.first_name && touched.first_name &&
                        <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.first_name}</div>
                    }

                    <div className="md:flex items-center gap-10">
                        <label className="md:w-32 text-right"> Last Name </label>
                        <div className="flex-1 max-md:mt-4">
                            <Field type="text" name="last_name" className="lg:w-1 w-full" />
                        </div>
                    </div>

                    {
                        errors.last_name && touched.last_name &&
                        <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.last_name}</div>
                    }

                    <div className="md:flex items-center gap-10">
                        <label className="md:w-32 text-right"> Mobile Number </label>
                        <div className="flex-1 max-md:mt-4">
                            {
                                loginType === '1' &&
                                <Field type="text" name="mobile" className="lg:w-1 w-full" readOnly />
                            }
                            {
                                loginType === '0' &&
                                <Field type="text" name="mobile" className="lg:w-1 w-full" />
                            }
                        </div>
                    </div>

                    {
                        errors.mobile && touched.mobile &&
                        <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.mobile}</div>
                    }

                    <div className="md:flex items-center gap-10">
                        <label className="md:w-32 text-right"> Email id </label>
                        <div className="flex-1 max-md:mt-4">
                            <Field type="email" name="email" className="lg:w-1 w-full" />
                        </div>
                    </div>

                    {
                        errors.email && touched.email &&
                        <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.email}</div>
                    }
                    {
                        loginType === '1' &&

                        <div className="md:flex items-center gap-10">
                            <label className="md:w-32 text-right"> Company/firm/agency </label>
                            <div className="flex-1 max-md:mt-4">
                                <Field type="text" name="company" className="lg:w-1 w-full" readOnly />
                            </div>
                        </div>
                    }
                    {
                        errors.company && touched.company &&
                        <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.company}</div>
                    }
                    {
                        loginType === '1' &&
                        <div className="md:flex items-center gap-10">
                            <label className="md:w-32 text-right"> GSTIN NO </label>
                            <div className="flex-1 max-md:mt-4">
                                <Field type="text" name="gstin" className="lg:w-1 w-full" readOnly />
                            </div>
                        </div>
                    }
                    {
                        loginType === '1' &&
                        <div className="md:flex items-center gap-10">
                            <label className="md:w-32 text-right"> PAN</label>
                            <div className="flex-1 max-md:mt-4">
                                <Field type="text" name="pan" className="lg:w-1 w-full" readOnly />
                            </div>
                        </div>
                    }
                    {
                        loginType === '1' &&
                        <div className="md:flex items-center gap-10">
                            <label className="md:w-32 text-right"> State</label>
                            <div className="flex-1 max-md:mt-4">
                                <Field type="text" name="state" className="lg:w-1 w-full" />
                            </div>
                        </div>
                    }
                    {
                        errors.state && touched.state &&
                        <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.state}</div>
                    }

                    <div className="md:flex items-center gap-10">
                        <label className="md:w-32 text-right"> City</label>
                        <div className="flex-1 max-md:mt-4">
                            <Field type="text" name="city" className="lg:w-1 w-full" />
                        </div>
                    </div>
                    {
                        errors.city && touched.city &&
                        <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.city}</div>
                    }
                    {
                        loginType === '1' &&
                        <div className="md:flex items-center gap-10">
                            <label className="md:w-32 text-right"> Pincode</label>
                            <div className="flex-1 max-md:mt-4">
                                <Field type="text" name="pincode" className="lg:w-1 w-full" />
                            </div>
                        </div>
                    }
                    {
                        errors.pincode && touched.pincode &&
                        <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.pincode}</div>
                    }
                    {
                        loginType === '0' &&
                        <div className="md:flex items-center gap-10">
                            <label className="md:w-32 text-right"> Birthday </label>
                            <div className="flex-1 max-md:mt-4">
                                <Field type="text" name="dob" className="lg:w-1 w-full" />
                            </div>
                        </div>
                    }

                    <div className="md:flex items-center gap-10">
                        <label className="md:w-32 text-right"> Gender </label>
                        <div className="flex-1 max-md:mt-4">
                            <Field as="select" name="gender" className="!border-0 !rounded-md lg:w-1 w-full">
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </Field>
                        </div>
                    </div>

                    <div className="md:flex items-start gap-10">
                        <label className="md:w-32 text-right"> About your self </label>
                        <div className="flex-1 max-md:mt-4">
                            <Field as="textarea" name="about" className="w-full" rows="5"></Field>
                        </div>
                    </div>
                    {
                        errors.about && touched.about &&
                        <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.about}</div>
                    }

                    <div className="flex items-center justify-center gap-4 mt-16">
                        <button
                            onClick={() => {
                                navigate('/profile/' + userData['userId']);
                            }}
                            type="button" className="button lg:px-6 bg-secondery max-md:flex-1"> Cancle</button>
                        <button
                            onClick={() => {
                                if (!isValid) {
                                    setFieldTouched('first_name');
                                    setFieldTouched('last_name');
                                    setFieldTouched('dob');
                                    setFieldTouched('email');
                                    setFieldTouched('gender');
                                    setFieldTouched('company');
                                    setFieldTouched('gstin');
                                    setFieldTouched('regcode');
                                    setFieldTouched('pan');
                                    setFieldTouched('state');
                                    setFieldTouched('city');
                                    setFieldTouched('pincode');
                                } else {
                                    handleSubmit();
                                }
                            }}
                            type="button" className="button lg:px-10 bg-primary text-white max-md:flex-1"> Save <span className="ripple-overlay"></span></button>
                    </div>

                </div>

            )}
        </Formik>
        {
            editApi.isLoader &&
            <div role="status" style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: '#ffffffb8', justifyItems: 'center', alignContent: 'center' }}>
                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                <span class="sr-only">Loading...</span>
            </div>
        }

    </div>

}